// @ts-nocheck
import { CameraMode } from '../../../src/defines';
import Status from '../helpers/Status';

export const viewerMixin = {
    status: new Status(),

    statsMode: 0,
    statsValues: {
        fps: 0,
        ms: 0,
        mb: 0,
    },

    /// FPS,MS,MB counter
    loop(timestamp: number) {
        const frameStart = performance.now();

        if (this.status) {
            this.status.begin();
        }

        if (Potree.measureTimings) {
            performance.mark('loop-start');
        }

        this.update(this.clock.getDelta(), timestamp);
        this.render();

        if (Potree.measureTimings) {
            performance.mark('loop-end');
            performance.measure('loop', 'loop-start', 'loop-end');
        }

        this.resolveTimings(timestamp);

        Potree.framenumber++;

        if (this.status) {
            this.status.end();

            // FPS
            this.statsValues.fps = this.status.getFPS();

            // MS
            this.statsValues.ms = performance.now() - frameStart;

            // MB
            if (performance.memory) {
                this.statsValues.mb = performance.memory.usedJSHeapSize / 1048576;
            } else {
                this.statsValues.mb = 0;
            }

            this.updateStatsDisplay();
        }
    },

    updateStatsDisplay() {
        if ($('#footer').find('#footer_left_row_col_two').length === 0) {
            return;
        }

        let label = '';
        let tooltip = '';

        switch (this.statsMode) {
            case 0:
                label = `FPS: ${(this.statsValues.fps ?? 0).toFixed(2)}`;
                tooltip = 'Frames Per Second';
                break;

            case 1:
                label = `MS: ${(this.statsValues.ms ?? 0).toFixed(2)}`;
                tooltip = 'Milliseconds Per Frame';
                break;

            case 2:
                label = `MB: ${(this.statsValues.mb ?? 0).toFixed(2)}`;
                tooltip = 'Used JS Heap Memory';
                break;
        }

        const footer = $('#footer').find('#footer_left_row_col_two');

        if ($('#footer').find('.lblstats').length > 0) {
            const statsElement = $('#footer').find('.lblstats')[0];

            statsElement.innerHTML = label;

            const tooltipElement = document.createElement('span');
            tooltipElement.classList.add('tooltiptext');
            tooltipElement.innerHTML = tooltip;

            statsElement.appendChild(tooltipElement);
        } else {
            const statsElement = document.createElement('div');

            statsElement.classList.add('lblstats');
            statsElement.classList.add('elementWithTooltip');

            statsElement.style.cursor = 'pointer';

            statsElement.innerHTML = label;

            const tooltipElement = document.createElement('span');
            tooltipElement.classList.add('tooltiptext');
            tooltipElement.innerHTML = tooltip;

            statsElement.appendChild(tooltipElement);

            // Rotate modes on click
            statsElement.addEventListener('click', () => {
                this.statsMode = (this.statsMode + 1) % 3;

                this.updateStatsDisplay();
            });

            footer[0].appendChild(statsElement);
        }
    },

    /// COMPAS

    toggleCompass() {
        this.compass.setVisible(!this.compass.visible);
    },

    setDeformationRange(value) {
        if (this.deformationRange !== value) {
            this.deformationRange = value;

            this.dispatchEvent({
                type: 'deformation_range_changed',
                viewer: this,
            });
        }
    },

    update(delta, timestamp) {
        if (Potree.measureTimings) performance.mark('update-start');

        this.dispatchEvent({
            type: 'update_start',
            delta: delta,
            timestamp: timestamp,
        });

        const scene = this.scene;
        const camera = scene.getActiveCamera();
        const visiblePointClouds = this.scene.pointclouds.filter((pc) => pc.visible);

        Potree.pointLoadLimit = Potree.pointBudget * 2;

        const lTarget = camera.position.clone().add(camera.getWorldDirection(new THREE.Vector3()).multiplyScalar(1000));
        this.scene.directionalLight.position.copy(camera.position);
        this.scene.directionalLight.lookAt(lTarget);

        for (const pointcloud of visiblePointClouds) {
            pointcloud.showBoundingBox = this.showBoundingBox;
            pointcloud.generateDEM = this.generateDEM;
            pointcloud.minimumNodePixelSize = this.minNodeSize;

            const material = pointcloud.material;

            material.uniforms.uFilterReturnNumberRange.value = this.filterReturnNumberRange;
            material.uniforms.uFilterNumberOfReturnsRange.value = this.filterNumberOfReturnsRange;
            material.uniforms.uFilterGPSTimeClipRange.value = this.filterGPSTimeRange;
            material.uniforms.uFilterPointSourceIDClipRange.value = this.filterPointSourceIDRange;

            material.classification = this.classifications;
            material.recomputeClassification();

            this.updateMaterialDefaults(pointcloud);
        }

        {
            if (this.showBoundingBox) {
                let bbRoot = this.scene.scene.getObjectByName('potree_bounding_box_root');
                if (!bbRoot) {
                    const node = new THREE.Object3D();
                    node.name = 'potree_bounding_box_root';
                    this.scene.scene.add(node);
                    bbRoot = node;
                }

                const visibleBoxes = [];
                for (const pointcloud of this.scene.pointclouds) {
                    for (const node of pointcloud.visibleNodes.filter((vn) => vn.boundingBoxNode !== undefined)) {
                        const box = node.boundingBoxNode;
                        visibleBoxes.push(box);
                    }
                }

                bbRoot.children = visibleBoxes;
            }
        }

        if (!this.freeze) {
            const result = Potree.updatePointClouds(scene.pointclouds, camera, this.renderer);

            const tStart = performance.now();
            const campos = camera.position;
            let closestImage = Infinity;
            for (const images of this.scene.orientedImages) {
                for (const image of images.images) {
                    const distance = image.mesh.position.distanceTo(campos);

                    closestImage = Math.min(closestImage, distance);
                }
            }
            const tEnd = performance.now();

            if (result.lowestSpacing !== Infinity) {
                let near = result.lowestSpacing * 10.0;
                let far = -this.getBoundingBox().applyMatrix4(camera.matrixWorldInverse).min.z;

                far = Math.max(far * 1.5, 10000);
                near = Math.min(100.0, Math.max(0.01, near));
                near = Math.min(near, closestImage);
                far = Math.max(far, near + 10000);

                if (near === Infinity) {
                    near = 0.1;
                }

                camera.near = near;
                camera.far = far;
            } else {
                // don't change near and far in this case
            }

            if (this.scene.cameraMode == CameraMode.ORTHOGRAPHIC) {
                camera.near = -camera.far;
            }
        }

        this.scene.cameraP.fov = this.fov;

        const controls = this.getControls();
        if (controls === this.deviceControls) {
            this.controls.setScene(scene);
            this.controls.update(delta);

            this.scene.cameraP.position.copy(scene.view.position);
            this.scene.cameraO.position.copy(scene.view.position);
        } else if (controls !== null) {
            controls.setScene(scene);
            controls.update(delta);

            if (typeof debugDisabled === 'undefined') {
                this.scene.cameraP.position.copy(scene.view.position);
                this.scene.cameraP.rotation.order = 'ZXY';
                this.scene.cameraP.rotation.x = Math.PI / 2 + this.scene.view.pitch;
                this.scene.cameraP.rotation.z = this.scene.view.yaw;
            }

            this.scene.cameraO.position.copy(scene.view.position);
            this.scene.cameraO.rotation.order = 'ZXY';
            this.scene.cameraO.rotation.x = Math.PI / 2 + this.scene.view.pitch;
            this.scene.cameraO.rotation.z = this.scene.view.yaw;
        }

        camera.updateMatrix();
        camera.updateMatrixWorld();
        camera.matrixWorldInverse.copy(camera.matrixWorld).invert();

        {
            if (this._previousCamera === undefined) {
                this._previousCamera = this.scene.getActiveCamera().clone();
                this._previousCamera.rotation.copy(this.scene.getActiveCamera().rotation);
            }

            if (!this._previousCamera.matrixWorld.equals(camera.matrixWorld)) {
                this.dispatchEvent({
                    type: 'camera_changed',
                    previous: this._previousCamera,
                    camera: camera,
                });
            } else if (!this._previousCamera.projectionMatrix.equals(camera.projectionMatrix)) {
                this.dispatchEvent({
                    type: 'camera_changed',
                    previous: this._previousCamera,
                    camera: camera,
                });
            }

            this._previousCamera = this.scene.getActiveCamera().clone();
            this._previousCamera.rotation.copy(this.scene.getActiveCamera().rotation);
        }

        {
            // update clip boxes
            let boxes = [];
            let crops = [];

            // volumes with clipping enabled
            boxes.push(...this.scene.volumes.filter((v) => v.clip && v.typeString === 'BoxClipVolume'));

            // crop box
            if (this.scene.boxCropVolume) {
                crops.push(this.scene.boxCropVolume);
                boxes.push(this.scene.boxCropVolume);
            }

            boxes = boxes.filter((box) => box.initialized);
            crops = crops.filter((box) => box.initialized);

            // profile segments
            for (const profile of this.scene.profiles) {
                boxes.push(
                    ...profile.boxes.map((box) => {
                        box.typeString = profile.typeString;
                        box.shouldHighlight = profile.shouldHighlight;
                        return box;
                    })
                );
            }

            // Needed for .getInverse(), pre-empt a determinant of 0, see #815 / #816
            const degenerate = (box) => box.matrixWorld.determinant() !== 0;

            const clipBoxes = boxes.filter(degenerate).map((box) => {
                box.updateMatrixWorld();

                const boxInverse = box.matrixWorld.clone().invert();
                const boxPosition = box.getWorldPosition(new THREE.Vector3());

                return { box: box, inverse: boxInverse, position: boxPosition };
            });

            const validClips = this.scene.polygonClipVolumes.filter((vol) => vol.initialized);
            const clipPolygons =
                this.scene.polygonCropVolume && this.scene.polygonCropVolume.initialized
                    ? [...validClips, this.scene.polygonCropVolume]
                    : validClips;

            // set clip volumes in material
            for (const pointcloud of visiblePointClouds) {
                pointcloud.material.setClipBoxes(clipBoxes);
                pointcloud.material.setClipPolygons(clipPolygons, this.clippingTool.maxPolygonVertices);
                pointcloud.material.clipTask = this.clipTask;
                pointcloud.material.clipMethod = this.clipMethod;
            }
        }

        {
            for (const pointcloud of visiblePointClouds) {
                pointcloud.material.elevationGradientRepeat = this.elevationGradientRepeat;
            }

            if (this.deformationRange) {
                for (const pointcloud of visiblePointClouds) {
                    pointcloud.material.deformationRange = this.deformationRange;
                    pointcloud.material.setStepColours([
                        0, 0, 0, 102, 0, 102, 153, 0, 204, 51, 51, 204, 0, 102, 255, 0, 153, 255, 50, 206, 176, 74, 210,
                        74, 118, 255, 33, 204, 255, 102, 255, 255, 0, 255, 153, 51, 255, 102, 0, 255, 0, 0, 204, 0, 0,
                    ]);
                    pointcloud.material.setDeformationSteps(this.deformationRange);
                }
            }
        }

        {
            // update navigation cube
            this.navigationCube.update(camera.rotation);
        }
        this.updateAnnotations();

        if (this.mapView) {
            this.mapView.update(delta);
            if (this.mapView.sceneProjection) {
                $('#potree_map_toggle').css('display', 'block');
            }
        }

        TWEEN.update(timestamp);

        this.dispatchEvent({
            type: 'update',
            delta: delta,
            timestamp: timestamp,
        });

        if (Potree.measureTimings) {
            performance.mark('update-end');
            performance.measure('update', 'update-start', 'update-end');
        }
    },
};
